import DragModal from "../../common/components/DragModal";
import {
  DialogContent,
  Divider,
  Typography,
  Button,
  Grid,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  MenuItem,
} from "@mui/material";
import { TagListContext } from "../../common/contexts/TagListContext";
import { useContext, useState } from "react";
import { TenantContext } from "../../common/contexts/TenantContext";
import { sortBy, filter } from "lodash";
import { appendTagLayerToTagList } from "../../api/APIHelpers";

export const AppendToTagList = ({
  open,
  onClose,
  editedTags,
  selectedTags,
}) => {
  const availableTagLists = useContext(TagListContext);
  const tenantInfo = useContext(TenantContext);
  const [selectedTagList, setSelectedTagList] = useState("");

  const append = async (tagListId) => {
    let tagsToSave = filter(editedTags, (_, index) => selectedTags.has(index));
    for (const tag of tagsToSave) {
      await appendTagLayerToTagList(tagListId, tag);
    }
  };

  const getTaglistNameTenant = (option) => {
    let tagListTenant =
      tenantInfo.availableTenants &&
      tenantInfo.availableTenants.find((t) => t.TenantId === option.TenantId);
    let tagListTenantName = "";
    if (tagListTenant) {
      tagListTenantName = `(${tagListTenant.DisplayName})`;
    }
    let tagListName =
      option.Name || `Unnamed TagList - ID ${option.TCTagListId}`;
    return `${tagListName} ${tagListTenantName} ${option.IsTagStandard ? " (Tag Standard)" : ""}`;
  };

  return (
    <DragModal
      open={open}
      title='editTagsSource'
      onClose={onClose}
      fullWidth
      maxWidth='lg'
      titlecomponent={
        <Typography variant='h5' color='primary'>
          Append to Tag List
        </Typography>
      }>
      <Divider />
      <DialogContent>
        <Grid container spacing={1} columns={1}>
          <Grid item sx={{ minWidth: 300 }} xs={1}>
            <FormControl sx={{ width: 600 }}>
              <InputLabel id='tag-standard-label'>Tag List</InputLabel>
              <Select
                size={"large"}
                input={<OutlinedInput label='Tag List' />}
                value={selectedTagList}
                onChange={(e) => {
                  setSelectedTagList(e.target.value);
                }}>
                {availableTagLists.TagLists &&
                  sortBy(availableTagLists.TagLists, (tagList) => {
                    return tagList.Name;
                  }).map((tagList, index) => {
                    return (
                      <MenuItem key={index} value={tagList.TCTagListId}>
                        {getTaglistNameTenant(tagList)}
                      </MenuItem>
                    );
                  })}
                {!availableTagLists.TagLists && (
                  <MenuItem value={""}>None</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <Button
              onClick={async () => {
                await append(selectedTagList);
                onClose();
              }}
              variant='outlined'>
              Append
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </DragModal>
  );
};
